import React, { useEffect, useState, useRef, useCallback } from 'react';
import SelectWithTokensActiveItem from '../../../shared/SelectWithTokensActiveItem';
import SelectWithTokensInput from '../../../shared/SelectWithTokensInput';
import SelectWithTokensSelectList from '../../../shared/SelectWithTokensSelectList';
import { ChevronIcon } from '../../../appearence/icons/chevron_icon';
import { MOUSE_DOWN_EVENT } from '../../../constant';

const checkSelectedForms = (selectWithTokensManager) => {
    return selectWithTokensManager.getCurrentItems() && selectWithTokensManager.getCurrentItems().length;
};

const ProductPropertySelect = ({ selectWithTokensManager }) => {
    const [selectListIsOpen, setSelectListIsOpen] = useState(false);
    const [activeListIsChanged, setActiveListIsChanged] = useState(false);
    const wrapperRef = useRef();

    const openItemsList = () => {
        setSelectListIsOpen(true);
    };

    const handleClickOutside = useCallback((event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setSelectListIsOpen(false);
        }
    }, []);

    const changeActiveList = () => {
        setActiveListIsChanged(prev => !prev);
    };

    useEffect(() => {
        document.addEventListener(MOUSE_DOWN_EVENT, handleClickOutside);
        selectWithTokensManager.registerItemsChangingObserver(changeActiveList);
        return () => {
            document.removeEventListener(MOUSE_DOWN_EVENT, handleClickOutside);
            selectWithTokensManager.unRegisterItemsChangingObserver(changeActiveList);
        };
    }, []);

    return (
        <>
            <label className="block__text product__form-label" >
                <div ref={wrapperRef}>
                    <div className="product__forms relative mt-0 flex min-h-[46px] w-full cursor-pointer flex-wrap items-start justify-between rounded-input border border-solid border-light-grey bg-white px-16 py-8" onClick={openItemsList}>
                        {checkSelectedForms(selectWithTokensManager) ? 
                            <ul className={`product__forms-list ${selectWithTokensManager.getCurrentItems().length === 0 ? 'product__forms-list_full-width' : ''}`}>
                                {selectWithTokensManager.getCurrentItems().map((it) => (
                                    <React.Fragment key={it.itemId + 'product' + activeListIsChanged}>
                                        <SelectWithTokensActiveItem
                                            selectItem={{...it, isLastItem: selectWithTokensManager.getCurrentItems().length === 1}} 
                                            removeCallback={selectWithTokensManager}
                                        />
                                    </React.Fragment>
                                ))}
                                    
                            </ul>
                            :
                            null}
                        {selectListIsOpen || selectWithTokensManager.getCurrentItems().length === 0 ? 
                            <SelectWithTokensInput selectWithTokensManager={selectWithTokensManager} />
                            :
                            null}
                        <ChevronIcon
                            nameOfClass={`product__forms-icon ${selectListIsOpen ? 'product__forms-icon_active' : ''}`} />
                    </div>
                    {selectListIsOpen ? 
                        <div className="product__forms-dropdown product__select-dropdown">
                            <SelectWithTokensSelectList selectWithTokensManager={selectWithTokensManager} include={true}/>
                        </div>
                        :
                        null}
                </div>
            </label>
        </>
    );
};


export default ProductPropertySelect;
